import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/userinfo',
  redirect: 'noredirect',
  name: 'userinfo',
  component: Layout,
  children: [
    {
      path: 'userinfo',
      component: () => import('@/views/userinfo/index.vue'),
      name: 'userinfo',
      meta: {
        title: '个人中心',
        icon: 'userinfo',
        requireAuth: true,
      }
    },
  ]

}

export default equipRouter
